import { Text } from '~/@mid_ui/typography/Text'
import type { Investment } from '~/@pages_account-portfolio/investments/_investment_types/investment.types'
import { YieldCompoundingValue } from '~/@pages_investing/projects/_projects_ui/project-yield-text/ProjectYieldText'
import { IInvestmentStatus } from '~/@api/generated-api-types-account/Api'
import { ProjectPaymentTypeTooltip } from '~/@pages_investing/projects/_projects_ui/project-payment-type-label/ProjectPaymentTypeTooltip'
import { getProjectPaymentTypeLabel } from '~/@pages_investing/projects/_projects_ui/project-payment-type-label/getProjectPaymentTypeLabel'

type Props = {
  investment: Investment
}

function InvestmentYield({
  investment: {
    project: { paymentType },
    isYieldCompoundingAnnually,
    totalCalculatedYield,
    status,
    prereservationData,
  },
}: Props) {
  const isPreserved = status === IInvestmentStatus.Prereserved
  const value = isPreserved
    ? (prereservationData?.plan?.totalYieldPerAnnum ?? 0)
    : totalCalculatedYield
  // BE portfolio investments vracia `project.paymentType` (enum `IProjectPaymentType`,
  // hodnoty = pôvodné Meteor ID); `paymentTypeId` z tohto DTO odobral `OmitType`.
  // Template literal prevedie enum na literal union akceptovanú label funkciou.
  const paymentTypeLabel = getProjectPaymentTypeLabel(
    `${paymentType}`,
    isYieldCompoundingAnnually
  )

  return (
    <Text className="flex flex-row text-green-500 font-semibold gap-1">
      <YieldCompoundingValue
        value={value.toFixed(2).replace('.', ',')}
        isYieldCompounding={isYieldCompoundingAnnually === true}
        yieldIconSize={22}
        yieldIconArrowColor="#000"
        yieldPercentColor="#3bb200"
      />
      <span>p.a.</span>
      <ProjectPaymentTypeTooltip paymentTypeLabel={paymentTypeLabel} />
    </Text>
  )
}

export { InvestmentYield }
